/**
 * Org-authored follow-on products (warranty/repair/repo) share a serial,
 * not the original sale pointer.
 */
export function isFollowOnProductMetadata(metadata: Record<string, unknown> | null | undefined): boolean {
  return metadata?.follow_on === true;
}

export function metadataWithFollowOn(
  existing: Record<string, unknown> | null | undefined,
  followOn: boolean,
): Record<string, unknown> {
  return { ...(existing ?? {}), follow_on: followOn };
}
